import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Input } from "reactstrap";

const ZipcodeFilter = ({
  collapsed,
  searchTerm,
  setRadius,
  setSearchTerm,
  tglHide,
  isTabletView,
  toggled,
  tempRadius,
  handleRadiusChange,
  handleRadiusCommit,
  type,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <>
      <li className="psb-menu-header">
        <span className="sidebar-header-text">FILTERS</span>
      </li>
      <li className="psb-menu-item">
        <div
          className="location-filter"
          style={{ padding: collapsed ? "0" : "0 15px" }}
        >
          <h6
            className="filter-label"
            style={{
              marginBottom: "10px",
              fontWeight: "bold",
              display: collapsed ? "none" : "block",
            }}
          >
            Zipcode:
          </h6>
          <div className="d-flex gap-2">
            <Input
              placeholder="Search Your Zipcode..."
              onChange={(e) => {
                dispatch(setSearchTerm(e.target.value));
                dispatch(setRadius(15));
              }}
              value={searchTerm || ""}
              type="search"
              pattern="[0-9]*"
              onKeyDown={(e) => {
                if ((e.keyCode < 48 || e.keyCode > 57) && e.keyCode !== 8) {
                  e.preventDefault();
                }
              }}
            />
            <div className="d-lg-none d-xl-none p-0">
              <button
                className="btn btn-primary mobile-only m-0"
                onClick={tglHide}
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </li>
      {searchTerm && (
        <li className="psb-menu-item">
          <div
            className="location-filter"
            style={{
              padding: collapsed || (isTabletView && !toggled) ? "0" : "0 15px",
            }}
          >
            <h6
              className="filter-label"
              style={{
                marginBottom: "10px",
                display:
                  collapsed || (isTabletView && !toggled) ? "none" : "block",
              }}
            >
              Radius:
            </h6>
            <Input
              placeholder="Radius"
              type="range"
              min={0}
              max={100}
              onChange={handleRadiusChange}
              onMouseUp={handleRadiusCommit}
              onTouchEnd={handleRadiusCommit}
              value={tempRadius}
              className="w-100"
              step={1}
              style={{
                display:
                  collapsed || (isTabletView && !toggled) ? "none" : "block",
              }}
            />
            {!collapsed && !(isTabletView && !toggled) && (
              <p className="radius-text">{tempRadius} miles</p>
            )}
          </div>
        </li>
      )}
      {type === "bwv" && (
        <li className="psb-menu-item Business-btn mt-2">
          <button
            className="btn btn-sm btn-danger w-100 mb-3"
            onClick={() => {
              navigate("/create-service");
            }}
            style={{
              padding:
                collapsed || (isTabletView && !toggled) ? "0" : "8px 15px",
              display:
                collapsed || (isTabletView && !toggled) ? "none" : "block",
            }}
          >
            List your Business
          </button>
        </li>
      )}
    </>
  );
};

export default ZipcodeFilter;
